import React from "react";
import Modal from "react-modal";
import Loader from "./Loader";
import SnackBar from "./SnackBar";
import { TextField, FormControl, FormHelperText } from "@mui/material";
import ErrorText from "../ErrorText";
import { FormLabel } from "react-bootstrap";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "90%",
    overflow: "auto",
    padding: "40px 90px",
    marginLeft: "260px",
    marginTop: "3%",
    backgroundColor: "#EFF3F6",
  },
  overlay: { backgroundColor: "none" },
};

const customStylesSuccess = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "90%",
    overflow: "auto",
    padding: "40px 90px",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: { backgroundColor: "none" },
};

export default class AddOTABetaUpdated extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: props.activeModal || false,
      modalStateAftereOpen: "animated animated-duration-custom slideInDown",
      modalStateAftereOpenSuccess:
        "animated animated-duration-custom slideInDown",
      modalIsOpenSuccess: false,

      version: "",
      description: "",
      instructions: "",
      packagePath: null,

      loader: false,
      snackbarActive: false,
      snackbarMessage: "",
      showErrorMessage: false,
      showErrorMessageversion: false,
      fileErrorText: "",
    };
  }

  closeModal = () => {
    this.setState(
      { modalStateAftereOpen: "animated animated-duration-custom slideOutUp" },
      () => {
        setTimeout(() => {
          this.setState({ modalIsOpen: false }, () =>
            this.props.closeAllModal?.()
          );
        }, 500);
      }
    );
  };

  closeModalSuccess = () => {
    this.setState(
      {
        modalStateAftereOpenSuccess:
          "animated animated-duration-custom slideOutUp",
      },
      () => {
        setTimeout(() => {
          this.setState({ modalIsOpenSuccess: false }, () =>
            this.props.closeAllModal?.()
          );
        }, 500);
      }
    );
  };

  handleChangeInput = (name, value) => {
    this.setState({ [name]: value });
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedExtensions = [".zip", ".bin"];
      const fileExt = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (!allowedExtensions.includes(fileExt)) {
        this.setState({
          fileErrorText: "Only .zip or .bin files are allowed.",
          showErrorMessage: true,
          packagePath: null,
        });
        event.target.value = "";
        return;
      }

      this.setState({
        packagePath: file,
        fileErrorText: "",
        showErrorMessage: false,
      });
    }
  };

  fetchError = (noError) => { 
    let totalError = 4;
  
    const versionRegex = /^\d+(\.\d+){2}$/; // only X.Y.Z
  
    // Check version
    if (
      ErrorText("notEmpty", this.state.version) === "No Error" &&
      versionRegex.test(this.state.version)
    ) {
      totalError--;
    }
  
    if (ErrorText("notEmpty", this.state.description) === "No Error")
      totalError--;
  
    if (ErrorText("notEmpty", this.state.instructions) === "No Error")
      totalError--;
  
    if (this.state.packagePath) totalError--;
  
    if (totalError === 0) noError("NoError");
  };
  
  
   AddOTABeta = () => {
    this.setState({ showErrorMessage: true, showErrorMessageversion: true }, () => {
      this.fetchError((e) => {
        if (e === "NoError") {
          this.setState({ loader: true }, this.submitOTABeta);
        }
      });
    });
  };


  submitOTABeta = () => {
    const { version, description, instructions, packagePath } = this.state;
    let tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;

    const formData = new FormData();
    formData.append("version", version);
    formData.append("description", description);
    formData.append("instructions", instructions);
    formData.append("package", packagePath);

    fetch("/cloud/ota-update-beta/", {
      method: "POST",
      headers: {
        Authorization: tokenStored,
        "X-CSRFToken": localStorage.getItem("csrftoken"),
        // ❌ Don't set Content-Type here — browser will set with boundary for FormData
      },
      body: formData,
    })
      .then((res) => {
        if (res.status === 403) {
          localStorage.clear();
          window.location.href = "/session-timeout";
        }
        return res.json();
      })
      .then((data) => {
        this.setState({ loader: false });
        if (data.message !== "failure") {
          this.setState({
            modalIsOpen: false,
            modalIsOpenSuccess: true,
            version: "",
            description: "",
            instructions: "",
            packagePath: null,
            showErrorMessage: false,
          });
        } else {
          this.setState({
            snackbarActive: true,
            snackbarMessage: `${Object.keys(data.data)[0]}: ${
              data.data[Object.keys(data.data)[0]]
            }`,
          });
        }
      })
      .catch((err) => console.error(err));
  };

  render() {
    return (
      <>
        <SnackBar
          open={this.state.snackbarActive}
          handleSnackbarClose={() => this.setState({ snackbarActive: false })}
          message={this.state.snackbarMessage}
        />
        {this.state.loader && <Loader />}

        {/* Main Modal */}
        <Modal
          isOpen={this.state.modalIsOpen}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              {/* <i className="fas fa-times fa-2x mr-2"></i> */}
            </div>
          </div>
          <h3
            className="modal-heading text-uppercase mb-0"
            style={{ color: "#888888" }}
          >
            Add OTA Beta
          </h3>
          <div className="row">
            <div className="col-6">
              <TextField
                label="Version"
                variant="standard"
                fullWidth
                value={this.state.version}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^\d+(\.\d+){2}$/;
                  this.setState({ version: value });

                  if (value === "" || !regex.test(value)) {
                    this.setState({ showErrorMessageversion: true });
                  } else {
                    this.setState({ showErrorMessageversion: false });
                  }
                }}
                error={this.state.showErrorMessageversion}
                helperText={
                  this.state.showErrorMessageversion
                    ? this.state.version === ""
                      ? "Version cannot be empty"
                      : "Please enter version in format: V.P.M (e.g., 1.0.0)"
                    : ""
                }
                sx={{ mt: "3%" }}
              />
            </div>

            <div className="col-6">
              <FormControl
                error={Boolean(this.state.fileErrorText)}
                fullWidth
                sx={{ mt: "2.3%" }}
              >
                 <FormLabel
                  style={{ top: "-5px" }}
                  component="legend"
                  htmlFor="package-upload"
                >
                  Package File
                </FormLabel>
                <input
                  type="file"
                  accept=".zip,.bin"
                  onChange={this.handleFileUpload}
                />
                <FormHelperText>
                  {this.state.fileErrorText ||
                    (this.state.showErrorMessage && !this.state.packagePath
                      ? "Please upload the package file"
                      : "")}
                </FormHelperText>
              </FormControl>
            </div>

            <div className="col-6">
              <TextField
                label="Description"
                variant="standard"
                fullWidth
                multiline
                value={this.state.description}
                onChange={(e) =>
                  this.handleChangeInput("description", e.target.value)
                }
                error={
                  this.state.showErrorMessage &&
                  ErrorText("notEmpty", this.state.description) !== "No Error"
                }
                helperText={
                  this.state.showErrorMessage &&
                  ErrorText("notEmpty", this.state.description) !== "No Error"
                    ? "Please enter description"
                    : ""
                }
                sx={{ mt: "3%" }}
              />
            </div>

            <div className="col-6">
              <TextField
                label="Instructions"
                variant="standard"
                fullWidth
                multiline
                value={this.state.instructions}
                onChange={(e) =>
                  this.handleChangeInput("instructions", e.target.value)
                }
                error={
                  this.state.showErrorMessage &&
                  ErrorText("notEmpty", this.state.instructions) !== "No Error"
                }
                helperText={
                  this.state.showErrorMessage &&
                  ErrorText("notEmpty", this.state.instructions) !== "No Error"
                    ? "Please enter instructions"
                    : ""
                }
                sx={{ mt: "3%" }}
              />
            </div>
          </div>

          <div
            className="float-right"
            style={{ marginTop: "70px", marginRight: "-15px" }}
          >
            <div
              className="btn btn-new-grey"
              style={{ marginRight: "15px" }}
              onClick={this.closeModal}
            >
              Cancel
            </div>
            <div className="btn btn-new-green" onClick={this.AddOTABeta}>
              Add
            </div>
          </div>
        </Modal>

        {/* Success Modal */}
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
        >
          <div className="modal-add-device">
            <div
              className="float-right cross-times"
              onClick={this.closeModalSuccess}
            >
              <i className="fas fa-times fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">
              OTA Beta Added Successfully
            </h3>
            <i className="fas fa-check-circle update"></i>
            <br />
            <div className="btn btn-new-grey" onClick={this.closeModalSuccess}>
              Close
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
